import { FormController } from '@form-ts/core';
import { FormError } from 'src/modules/form/types/FormError';
import { RequestAccessFormData } from 'src/modules/login/types/RequestAccessFormData';
import { createTrigger } from 'src/utils/createTrigger';

export const REQUEST_ACCESS_SUBMIT =
  createTrigger<FormController<RequestAccessFormData, FormError>>('REQUEST_ACCESS_SUBMIT');
